import {filterByYear, getTopSums, getYearRange} from "../assets/utils";
import BPLOT from "./BPLOT";
import institution from '../assets/InstitutionPubCountByPentaslice';
import MultiRangeSlider from "./MultiRangeSlider";
import {useState} from "react";

const Author = () => {

    const yearRange = getYearRange(institution, 2)

    const startData = fetchData(yearRange[0], yearRange[1])

    const [minYear, setCurrentMin] = useState(yearRange[0])
    const [maxYear, setCurrentMax] = useState(yearRange[1] + 4)

    const [dataArray, setDataArray] = useState(startData)

    function fetchData(min, max) {
        const filteredData = filterByYear(institution, min, max, 2)
        const rankDeptDataREL = getTopSums(filteredData, 10, 0, 3, 1, 'Religion2020')
        const rankDeptDataCOP = getTopSums(filteredData, 10, 0, 3, 1, 'Cooperation2021')
        const rankDeptDataBOTH = getTopSums(filteredData, 10, 0, 3, 1, 'CooperationAndReligion')

        return [rankDeptDataREL, rankDeptDataCOP, rankDeptDataBOTH]
    }

    function buttonClicked() {
        const min = parseInt(document.getElementById('leftInstVal').textContent)
        const max = parseInt(document.getElementById('rightInstVal').textContent)

        const filteredData = fetchData(min - (min % 5), max - (max % 5))
        setCurrentMin(min - (min % 5))
        setCurrentMax(max - (max % 5) + 4)
        setDataArray(filteredData)
    }

    return (
        <>
            <div className={'row range-slider'}>
                <div className={'col'}/>
                <div className={'col'}>
                    <MultiRangeSlider
                        min={yearRange[0]}
                        max={yearRange[1] + 4}
                        cat={'Inst'}
                        onChange={({min, max}) => {
                            console.log()
                        }}
                    />
                </div>
                <div className={'col'}>
                    <button className={'btn btn-primary filter-button'} onClick={buttonClicked}>Filter</button>
                </div>
            </div>

            <div className={'row top-row'}>
                <div className={'col centered-text'}>
                    {
                        'Top 10 Institutions by Number of Publications between ' + minYear + ' and ' + maxYear
                    }
                </div>
            </div>

            <div className={"row"}>
                <div className={'col-4'}>
                    <BPLOT
                        title={'Religion'}
                        data={dataArray[0]}
                        height={0.7}/>
                </div>
                <div className={'col-4'}>
                    <BPLOT
                        title={'Cooperation'}
                        data={dataArray[1]}
                        height={0.7}/>
                </div>
                <div className={'col-4'}>
                    <BPLOT
                        title={'Religion and Cooperation'}
                        data={dataArray[2]}
                        height={0.7}/>
                </div>
            </div>
        </>
    );
}

export default Author;